export const environment = {
  appId: 'rw3-web-admin',
  envName: 'prod',
  production: true,
  rw3apiURL: 'https://refworks.proquest.com/api-ipa/',
  pendoApiKey: 'd01e10b8-c362-4465-7aca-2ea404e24ea6'
};
